'use client';
import {useSWRMutateApi} from '@linx-security/api/react';
import type {AvailableEndpoints, CacheKey, EndpointParams} from '@linx-security/api/react';
import {useState} from 'react';
import type {SWRMutationConfiguration} from 'swr/mutation';

import {getClient} from '../(admin)/_lib/ApiClient';
import type {ConsoleApi} from '../(admin)/_lib/ConsoleApi';

/**
 *  @description React hook that accepts client generated by openapi-generator typescript-fetch
 */
export const useMutateApi = <
  TClient extends ConsoleApi,
  TKey extends AvailableEndpoints<TClient> | CacheKey<object, TClient>,
  TEndpointFunction extends TKey extends AvailableEndpoints<TClient>
    ? TClient[TKey]
    : TKey extends CacheKey<object, TClient>
      ? TClient[TKey[`endpoint`]]
      : never,
  TParams extends TEndpointFunction extends (...args: any) => any ? Parameters<TEndpointFunction>[0] : never,
  TResponse extends Awaited<ReturnType<TEndpointFunction extends (...args: any) => any ? TEndpointFunction : never>>,
>(
  key: TKey,
  config: SWRMutationConfiguration<TResponse, Error, [TKey], TParams> = {},
) => {
  const [client] = useState(getClient());

  // @ts-expect-error: we handle legacy cache keys in the hook
  return useSWRMutateApi(client, key as unknown as TKey, config as any);
};

export default useMutateApi;

export type ApiEndpointsParams<Endpoint extends AvailableEndpoints<ConsoleApi> = AvailableEndpoints<ConsoleApi>> =
  EndpointParams<Endpoint, ConsoleApi>;
